<template>
  <NavigationLayout
    navigationTitle="本人情報"
    :navigationBarStyle="{
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigationContentStyle="{
      'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
    }"
  >
    <div id="personal__wrapper" slot="contents">
      <div id="personal__container">
        <section>
          <div
            v-bind:style="VerifyResultsReasonsStyle"
            v-if="isVerifyResultExists"
          >
            <p
              v-for="(reason, index) in verifyResultReasons"
              :key="`verify_result_${index}`"
            >
              {{ reason }}
            </p>
          </div>
          <ListItem
            title="姓（全角）"
            v-bind:warning="verifyResultKeys.includes('family_name')"
          >
            <input
              slot="actionInput"
              :value="depositAccount.family_name"
              @input="input($event, 'family_name')"
              type="text"
              name="family_name"
              placeholder="例)山田"
              size="8"
              required
            />
          </ListItem>
          <ListItem
            title="名（全角）"
            v-bind:warning="verifyResultKeys.includes('first_name')"
          >
            <input
              slot="actionInput"
              :value="depositAccount.first_name"
              @input="input($event, 'first_name')"
              type="text"
              name="first_name"
              placeholder="例)花子"
              size="8"
              required
            />
          </ListItem>
          <ListItem
            title="姓カナ（全角）"
            v-bind:warning="verifyResultKeys.includes('family_name_kana')"
          >
            <input
              slot="actionInput"
              :value="depositAccount.family_name_kana"
              @input="input($event, 'family_name_kana')"
              type="text"
              name="family_name_kana"
              placeholder="例)ヤマダ"
              size="8"
              required
            />
          </ListItem>
          <ListItem
            title="名カナ（全角）"
            v-bind:warning="verifyResultKeys.includes('first_name_kana')"
          >
            <input
              slot="actionInput"
              :value="depositAccount.first_name_kana"
              @input="input($event, 'first_name_kana')"
              type="text"
              name="first_name_kana"
              placeholder="例)ハナコ"
              size="8"
              required
            />
          </ListItem>
          <ListItem
            title="郵便番号"
            v-bind:warning="verifyResultKeys.includes('zip_code')"
          >
            <input
              slot="actionInput"
              :value="depositAccount.zip_code"
              @input="input($event, 'zip_code')"
              type="number"
              name="zip_code"
              placeholder="例)1234567"
              required
            />
          </ListItem>
          <ListItem
            title="住所"
            v-bind:warning="verifyResultKeys.includes('address')"
          >
            <input
              slot="actionInput"
              :value="depositAccount.address"
              @input="input($event, 'address')"
              v-bind:style="{ minWidth: '240px' }"
              type="text"
              name="address"
              placeholder="例)東京都港区六本木森タワー9F"
              required
            />
          </ListItem>
          <ListItem
            title="メールアドレス"
            v-bind:warning="verifyResultKeys.includes('mail_address')"
            v-bind:itemStyle="ListItemStyleSectionLast"
          >
            <input
              slot="actionInput"
              :value="depositAccount.mail_address"
              @input="input($event, 'mail_address')"
              v-bind:style="{ minWidth: '180px' }"
              type="email"
              name="mail_address"
              placeholder="入力してください"
              required
            />
          </ListItem>
        </section>
        <div>
          <div v-bind:style="CautionsStyle">
            <p>＊お客様の個人情報をご登録ください</p>
            <p>
              ＊ご入力いただいたお客様の個人情報は、当社から配信者様への報酬支払に伴う源泉徴収及び法定調書の作成、提出のために利用いたします。
            </p>
          </div>
        </div>
        <section id="personal__submit">
          <ButtonSubmit
            id="personal__submit_button"
            title="登録する"
            v-bind:disabled="!canSubmitInput"
            v-on:click.native="submit"
          />
        </section>
      </div>
      <SubmitNotification
        v-bind:isActive="isSubmitNotificationActive"
        v-bind:onEntered="onSubmitNotificationEntered"
      />
    </div>
  </NavigationLayout>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import NavigationLayout from '@/components/NavigationLayout'
import ListItem from '@/components/ListItem'
import ButtonSubmit from '@/components/ButtonSubmit'
import SubmitNotification from '@/components/SubmitNotification'
import MypageStyle from '@/styles/mypage'
export default {
  components: {
    NavigationLayout,
    ListItem,
    SubmitNotification,
    ButtonSubmit,
  },
  data: function () {
    return {
      CautionsStyle: MypageStyle.Cautions,
      VerifyResultsReasonsStyle: MypageStyle.VerifyResultsReasons,
      ListItemStyleSectionLast: MypageStyle.ListItemSectionLast,
    }
  },
  computed: {
    ...mapState({
      depositAccount: (state) => state.depositAccount.depositAccount,
      isSubmitNotificationActive: (state) =>
        state.components.submitNotification.isActive,
    }),
    ...mapGetters('depositAccount', [
      'isVerifyResultExists',
      'verifyResultKeys',
      'verifyResultReasons',
      'canSubmitInput',
    ]),
  },
  methods: {
    ...mapMutations('depositAccount', ['updateDepositAccountAttr']),
    ...mapActions('depositAccount', [
      'fetchDepositAccount',
      'postDepositAccountUpdate',
    ]),
    ...mapActions('components/submitNotification', {
      showSubmitNotification: 'show',
      onSubmitNotificationEntered: 'onEntered',
    }),
    input(e, name) {
      this.updateDepositAccountAttr({ name: name, value: e.target.value })
    },
    submit() {
      this.postDepositAccountUpdate()
        .then(this.showSubmitNotification)
        .catch(() => {})
    },
  },
  mounted() {
    this.fetchDepositAccount()
  },
}
</script>

<style scoped>
#personal__wrapper {
  position: relative;
  height: auto;
  min-height: 100%;
  background-color: #fafafa;
}
#personal__container {
  padding-top: 20px;
  padding-bottom: 49px;
}

#personal__container input {
  min-width: 144px;
  width: auto;
}

#personal__submit {
  margin-top: 40px;
}
#personal__submit_button {
  width: 224px;
  height: 44px;
  display: table;
  margin: auto;
}
</style>
